import { toPercent, toThousands } from '@/common/js/filters'

/**
 * @description: 筛选日期区间
 * @return {*}
 */
export const dateRanges = [
  {
    label: '今日',
    value: 1
  },
  {
    label: '昨日',
    value: 8
  },
  {
    label: '本周',
    value: 2
  },
  {
    label: '上周',
    value: 3
  },
  {
    label: '过去7天',
    value: 4
  },
  {
    label: '过去30天',
    value: 5
  },
  {
    label: '本月',
    value: 6
  },
  {
    label: '上月',
    value: 7
  }
]

/**
 * @description: 筛选日期区间，与小程序保持一致
 * @return {*}
 */
export const miniProgramDateRanges = [
  {
    label: '今天',
    value: 1
  },
  {
    label: '昨天',
    value: 2
  },
  {
    label: '本周',
    value: 3
  },
  {
    label: '上周',
    value: 4
  },
  {
    label: '本月',
    value: 5
  },
  {
    label: '上月',
    value: 6
  },
  {
    label: '自定义',
    value: 7
  }
]

/**
 * @description: 展示数据字段及折线图对比字段
 * @return {*}
 */
export const displayItems = [
  {
    label: '实际消耗',
    key: 'amount',
    value: 1,
    unit: '元',
    format(val) {
      return toThousands(val)
    }
  },
  {
    label: '在跑计划数',
    key: 'hasDataCount',
    value: 2
  },
  {
    label: '点击率',
    key: 'clickRate',
    value: 3,
    format(val) {
      return toPercent(val)
    }
  },
  {
    label: '激活',
    key: 'downNum',
    value: 4
  },
  {
    label: '激活成本',
    key: 'activeCost',
    value: 5,
    unit: '元',
    format(val) {
      return toThousands(val)
    }
  },
  {
    label: '创角',
    key: 'createRoleNum',
    value: 6
  },
  {
    label: '创角成本',
    key: 'createRoleCost',
    value: 7,
    unit: '元',
    format(val) {
      return toThousands(val)
    }
  },
  {
    label: '创角率',
    key: 'createRoleRate',
    value: 8,
    format(val) {
      return toPercent(val)
    }
  },
  {
    label: '创角付费率',
    key: 'payRoleUserRate',
    value: 9,
    format(val) {
      return toPercent(val)
    }
  },
  {
    label: '新创角充值金额',
    key: 'newRoleMoney',
    value: 10,
    unit: '元',
    format(val) {
      return toThousands(val)
    }
  },
  {
    label: '新创角回款率',
    key: 'newRoleRate',
    value: 11,
    format(val) {
      return toPercent(val)
    }
  },
  {
    label: '投放总流水',
    key: 'sumMoney',
    value: 12,
    unit: '元',
    format(val) {
      return toThousands(val)
    }
  },
  {
    label: '首日二次付费率',
    key: 'createRolePayTwiceRate',
    value: 13,
    format(val) {
      return toPercent(val)
    }
  },
  {
    label: '创角1小时内等级通过率',
    key: 'roleLevelReachOneHourRate',
    value: 15,
    format(val) {
      return toPercent(val)
    }
  },
  {
    label: '首日等级通过率',
    key: 'roleLevelReachNumRate',
    value: 16,
    format(val) {
      return toPercent(val)
    }
  },
  {
    label: '创角账号2日留存',
    key: 'createRoleRetain2d',
    value: 17,
    format(val) {
      return toPercent(val)
    }
  },
  {
    label: '创角账号3日留存',
    key: 'createRoleRetain3d',
    value: 18,
    format(val) {
      return toPercent(val)
    }
  },
  {
    label: '创角账号7日留存',
    key: 'createRoleRetain7d',
    value: 19,
    format(val) {
      return toPercent(val)
    }
  },
  {
    label: '创角账号15日留存',
    key: 'createRoleRetain15d',
    value: 20,
    format(val) {
      return toPercent(val)
    }
  },
  {
    label: '创角账号30日留存',
    key: 'createRoleRetain30d',
    value: 21,
    format(val) {
      return toPercent(val)
    }
  },
  {
    label: '创角账号1日ROI',
    key: 'createRoleRoi1',
    value: 22,
    format(val) {
      return toPercent(val)
    }
  },
  {
    label: '创角账号3日ROI',
    key: 'createRoleRoi3',
    value: 23,
    format(val) {
      return toPercent(val)
    }
  },
  {
    label: '创角账号7日ROI',
    key: 'createRoleRoi7',
    value: 24,
    format(val) {
      return toPercent(val)
    }
  },
  {
    label: '创角账号15日ROI',
    key: 'createRoleRoi15',
    value: 25,
    format(val) {
      return toPercent(val)
    }
  },
  {
    label: '创角账号30日ROI',
    key: 'createRoleRoi30',
    value: 26,
    format(val) {
      return toPercent(val)
    }
  }
]

/**
 * @description: 按某项排行
 * @return {*}
 */
export const rankItems = [
  {
    label: '按消耗排行',
    value: 'real_consume'
  },
  {
    label: '按创角数',
    value: 'create_role_num'
  },
  {
    label: '按ROI',
    value: 'new_role_roi'
  }
]

/**
 * @description: 根据媒体筛选下拉数据
 * @return {*}
 */
export const mediaItems = [
  {
    label: '消耗',
    value: 'amount',
    sort: 'real_consume'
  },
  {
    label: '展示数',
    value: 'pv',
    sort: 'pv'
  },
  {
    label: '激活数',
    value: 'downNum',
    sort: 'active_num'
  },
  {
    label: '注册量',
    value: 'newUserNum',
    sort: 'new_user_num'
  },
  {
    label: '创角数',
    value: 'createRoleNum',
    sort: 'create_role_num'
  },
  {
    label: '新创角付费人数',
    value: 'payRoleUserNum',
    sort: 'pay_role_user_num'
  },
  {
    label: '新创角付费金额',
    value: 'newRoleMoney',
    sort: 'create_role_money2_sum'
  },
  {
    label: '总流水',
    value: 'sumMoney',
    sort: 'sum_money'
  }
]
